/**
 * Constants used by InspectorTabs sub-components.
 */

import type { ActivityCategory } from './types';

// Re-export emptyForm from the shared inspector types
export { emptyForm } from '../inspector/types';

export const OPERATION_TYPES = [
  { value: 'direct', label: 'Direct Mapping' },
  { value: 'expression', label: 'Expression' },
  { value: 'aggregate', label: 'Aggregate (GROUP BY)' },
  { value: 'window', label: 'Window Function' },
  { value: 'cast', label: 'Type Cast' },
  { value: 'concat', label: 'Concatenation' },
  { value: 'conditional', label: 'Conditional (CASE WHEN)' },
  { value: 'filter', label: 'Filter (WHERE)' },
  { value: 'set_constant', label: 'Set Constant' },
  { value: 'pivot', label: 'Pivot' },
  { value: 'unpivot', label: 'Unpivot' },
] as const;

export const categoryConfig: Record<ActivityCategory, { label: string; color: 'warning' | 'primary' | 'info' }> = {
  manual_edit: { label: 'Manual Edit', color: 'warning' },
  ai_regeneration: { label: 'AI Regeneration', color: 'primary' },
  ai_mapping: { label: 'AI Mapping', color: 'info' },
};

export const templateLabel = (template: string): string => {
  const labels: Record<string, string> = {
    'map_fields': 'Field Mapping',
    'regenerate_field': 'Field Regeneration',
    'regenerate_mapping': 'Mapping Regeneration',
    'generate_mapping': 'Mapping Generation',
    'semantic_summary': 'Source Summarizer',
    'source_summarizer': 'Source Summarizer',
  };
  return labels[template] || template.replace(/_/g, ' ');
};

export const relativeTime = (ts: number): string => {
  const diff = Date.now() - ts;
  if (diff < 60_000) return 'just now';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
  return new Date(ts).toLocaleDateString();
};
